import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TenantResponse } from '@/repositories/generated';

const response: TenantResponse[] = [
  {
    id: '1',
    name: 'テナント1',
  },
  {
    id: '2',
    name: 'テナント2',
  },
  {
    id: '3',
    name: 'テナント3',
  },
];

export const autocompleteTenant = http.get(
  createMockEndpoint('/autocomplete/tenant'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
